import { shareColumnsExtend, shareFormColumnsExtend } from './share';
export const ROLE_KINDS = [
  'super',
  'application',
  'designer',
  'merchandiser',
  'salesman',
  'not_any',
  'custom',
  'sales_director',
  'supplier',
  'supplier_boss',
  'cheif_pattern_making_officier',
  'pattern_maker',
  'craftsman',
  'quality_inspector',
  'plate_reviewer',
  'purchaser',
  'guest',
]

const entityColumns = {
  id: {
    model_name: 'Role',
    column_type: 'id',
    label_key_path: 'role.id',
  },
  created_at: {
    model_name: 'Role',
    column_type: 'datetime',
    label_key_path: 'role.createdAt',
  },
  updated_at: {
    model_name: 'Role',
    column_type: 'datetime',
    label_key_path: 'role.updatedAt',
  },
  name: {
    model_name: 'Role',
    column_type: 'string',
    label_key_path: 'role.name',
  },
  kind: {
    model_name: 'Role',
    column_type: 'enum',
    extra: {
      options: ['super', 'application', 'designer', 'merchandiser', 'salesman', 'not_any', 'custom', 'sales_director', 'supplier', 'supplier_boss', 'cheif_pattern_making_officier', 'pattern_maker', 'craftsman', 'quality_inspector', 'plate_reviewer', 'purchaser', 'guest'],
    },
    label_key_path: 'role.kind',
  },
  custom_permissions: {
    model_name: 'Role',
    column_type: 'string',
    label_key_path: 'role.customPermissions',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
